module.exports = __webpack_public_path__ + "static/media/play_effect_start_game.1808df76.png";